import React from 'react';

export const DATA_ACCESS_TEXT_STYLE: React.CSSProperties = {
  fontSize: '0.875rem',
  lineHeight: 1.65,
};

type DataAccessTabHeaderProps = {
  title: string;
  children: React.ReactNode;
};

export const DataAccessTabHeader: React.FC<DataAccessTabHeaderProps> = ({ title, children }) => (
  <>
    <div className="d-flex align-items-center justify-content-between mb-4">
      <h3 className="text-primary mb-0">{title}</h3>
    </div>
    <div className="text-700 mb-4" style={DATA_ACCESS_TEXT_STYLE}>
      {children}
    </div>
    <div className="border-dashed border-bottom mb-4" />
  </>
);

type DataAccessSectionHeadingProps = {
  children: React.ReactNode;
  className?: string;
};

export const DataAccessSectionHeading: React.FC<DataAccessSectionHeadingProps> = ({
  children,
  className = 'mb-3',
}) => <h5 className={`text-900 fw-semi-bold ${className}`}>{children}</h5>;

type DataAccessTextProps = {
  children: React.ReactNode;
  className?: string;
  as?: 'p' | 'div' | 'li';
};

export const DataAccessText: React.FC<DataAccessTextProps> = ({
  children,
  className = 'text-700 mb-3',
  as: Component = 'p',
}) => (
  <Component className={className} style={DATA_ACCESS_TEXT_STYLE}>
    {children}
  </Component>
);
